import GraphHeader from './GraphHeader';

export default GraphHeader;
